export default __webpack_public_path__ + "static/media/img-stacking-banner-2-new.6dca81cf.png";